import { CbhFeatureFlag, useCbhFlag } from "../../FeatureFlags";

export function useJobRequestConfiguration(workplaceAllowsInterviewRequest: boolean) {
  const config = useCbhFlag(CbhFeatureFlag.REQUEST_PLACEMENT_INTERVIEW, {
    defaultValue: {
      enabled: false,
      maxInterviewsDatesToSelect: 3,
      maxInterviewsDatesToBeShown: 7,
    },
  });

  if (!workplaceAllowsInterviewRequest) {
    return { ...config, enabled: false };
  }

  return config;
}
